import { Investigation } from "../../lusca-search-api/generated-src";

/**
 * "Ready to resolve": a case still in MONITORING_REDRIVE whose redrive has stayed quiet. The
 * worker sets `latestRedrive.monitoringClearAt` once a DLQ snapshot taken at least the stage's
 * quiet period (default 4 hours) after the redrive finished shows none of its items back, and
 * notifies the owner. Resolving stays a person's call; a later return clears the flag and
 * reopens the case. Not a backend status: lists and chips show it in place of Monitoring redrive.
 */
export const READY_TO_RESOLVE = "READY_TO_RESOLVE";
export const READY_TO_RESOLVE_LABEL = "Ready to resolve";

type ClearFields = Pick<Investigation, "status" | "latestRedrive">;

export const monitoringClear = (inv?: ClearFields | null): boolean =>
  !!inv &&
  inv.status === "MONITORING_REDRIVE" &&
  !!inv.latestRedrive?.monitoringClearAt &&
  !inv.latestRedrive?.hasReturns;

/** The status a list row shows and filters on: READY_TO_RESOLVE for a quiet monitored case. */
export const rowStatus = (inv: ClearFields, shown: string): string =>
  monitoringClear(inv) ? READY_TO_RESOLVE : shown;

const timeOnly = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
});

/** "No returns in the 18:05 snapshot" — the evidence line under the passed Monitoring step. */
export const monitoringClearSummary = (inv?: ClearFields | null): string => {
  const at = inv?.latestRedrive?.monitoringClearSnapshotAt;
  const t = at ? Date.parse(at) : NaN;
  return Number.isNaN(t)
    ? "No redriven items came back"
    : `No returns in the ${timeOnly.format(t)} snapshot`;
};
